// import { borderRadius } from "@mui/system";
import { COLORS } from "../../../common/constants/colors";
// import { Opacity } from "@mui/icons-material";

const styles = {
  cardInput: { borderRadius: 10 },
  authInput: {
    "& input": {
      // padding: "16.5px 14px",
      color: COLORS.inputHead,
      font: "normal normal 400 16px/16px mreavesxlsanot-reg",
      "&::placeholder": {
        color: "#8c8c8c",
        letterSpacing: "0.59px",
        opacity: "1",
        font: "normal normal 400 16px/16px mreavesxlsanot-reg !important",
      },
      "&:-internal-autofill-selected": {
        backgroundColor: "transparent",
      },
    },
    "& textarea": {
      color: COLORS.inputHead,
      font: "normal normal 400 16px/16px mreavesxlsanot-reg",
      "&::placeholder": {
        color: "#8c8c8c",
        opacity: "1",
        letterSpacing: "0.59px",
        font: "normal normal 400 16px/16px  mreavesxlsanot-reg",
      },
      "&:-internal-autofill-selected": {
        backgroundColor: "transparent",
      },
    },
    "& .MuiOutlinedInput-notchedOutline": {
      border: "1px solid rgba(209, 209, 209, 1)",
    },
    "& .MuiInputBase-root.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
      {
        border: "1px solid rgba(209, 209, 209, 1)",
      },
    "& .MuiInputBase-root.MuiOutlinedInput-root.Mui-active .MuiOutlinedInput-notchedOutline":
      {
        border: "1px solid rgba(209, 209, 209, 1)",
      },
    "& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline": {
      border: "1px solid #ff5f30 !important",
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: "12px",
      font: "normal normal 500 16px/16px mreavesxlsanot-reg",
      // font: FontFamily(500, 16, 20),
    },
  },
  filled: {
    "& .MuiInputBase-root.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
      {
        border: "2px solid #2061A8;",
      },
  },
  notFilled: {},
  label: {
    font: "normal normal 500 16px/14px mreavesxlsanot-reg",
    letterSpacing: "0.59px",
    transition: "ease-in 0.5s",
    color: COLORS.inputHead,
    marginBottom: "10px",
  },
  labelIcon: { display: "flex", alignItems: "flex-start" },
  errorTooltip: {
    // maxWidth: "250px",
    display: "flex",
    flexDirection: "row",
    // justifyContent: "center",
    alignItems: "center",
    gap: "10px",
    color: "#FF5F30 !important",
    // padding: "20px",
    // background: COLORS.themeError,
    font: "normal normal 500 16px/16px mreavesxlsanot-reg",
  },
  passwordRow: {
    width: "100%",
    display: "flex",
    alignItems: "center",
  },
  visibilityIcon: { color: COLORS.darkGrey },
  errorIcon: { color: COLORS.themeError },
  none: { visibility: "hidden" },
  infoIcon: {
    marginLeft: "5px",
    width: "15px",
  },
  customTooltip: {
    font: "normal normal 400 20px/24px mreavesxlsanot-reg",
    color: "#000",
    listStyle: "disc",
  },
  tooltiplist: {
    listStyle: "disc",
  },
  paratext: {
    font: "normal normal 400 20px/24px mreavesxlsanot-reg",
  },
};

export default styles;
